import React, {FC, useEffect, useMemo, useState} from "react";
import {
  Container,
  WrapperRow,
  Title,
  HideWrapper,
  BlueText,
  LeftSide,
  BodyText,
  BodyLink,
  QuotasContainer,
  StateWrapper,
  GreenDot,
  Greentext
} from '../Instances/styles'
import { Diagrams } from "../../HomePage/components";
import { useTranslation } from "react-i18next";
import { icons } from "../../../icons";
import StyledIcon from "../../../components/styled-icon";
import { Button, ModalVariables, StartPage, Table, TutorialVodeo, SearchComponent, FilterBar } from "../../../components";
import TutorImg from './illustration.svg'
import TutorDarkImg from './illustration-dark.svg'
import { useTheme } from "styled-components";
import { useNavigate } from "react-router";
import { useUi } from "../../../context/ui.context";
import { useAuth } from "../../../context/user.context";
import { NumberParam, StringParam, useQueryParam } from "use-query-params";
import { compareArrays } from "../../../utils/findIntersection";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import rootConfig from "../../../config";
import useUpdateEffect from "../../../hooks/useUpdateEffect";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
import { flavorService } from "../../../api";
import { handleStatusName } from "../../../utils/handle-status-name";

const FLAVOR_FILTER_KEYS = [
  'region',
  'memory_mb',
  'root_gb',
  'vcpus',
  'is_public',
  'flavor_group',
];

const DEFAULT_ORDERING = '-created_at';

const Flavors:FC = () => {
  const [flavors, setFlavors] = useState<any[]>([])
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [searchString, setSearchString] = useQueryParam('search', StringParam);
  const [filtering, setFiltering] = useQueryParam('filtering', StringParam);
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [paginationData, setPaginationData] = useState<any>()
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [deletedFlavor, setDeletedFlavor] = useState<any>()
  const [allChecked, setAllChecked] = useState<boolean>(false)
  const [checked, setChecked] = useState<any[]>([])
  const [filterOptions, setFilterOptions] = useState<any>()
  const {
    viewAlert,
  } = useUi()
  const [t] = useTranslation()
  const normalizedFilterOptions = useMemo(() => {
    if (!filterOptions) return undefined;
    const base: Record<string, any> = {};
    FLAVOR_FILTER_KEYS.forEach((key) => {
      if (Array.isArray(filterOptions?.[key]) && filterOptions?.[key]?.length) {
        base[key] = filterOptions[key];
      }
    });
    // Fallback for boolean filter 'is_public'
    const booleanOptions = [
      { display: t("YES"), value: 'true' },
      { display: t("NO"), value: 'false' },
    ];
    if (!base.is_public) {
      base.is_public = booleanOptions;
    }
    return base;
  }, [filterOptions, t]);
  const handleResetFilters = () => {
    setSearchString(undefined);
    setFiltering(undefined);
    setOrdering(DEFAULT_ORDERING);
    setPage(1);
    setAllChecked(false);
    setChecked([]);
  }
  const {user, quotas} = useAuth()
  const editChecked = (id:any, isAll?:boolean) => {
    if(id === null) {
      setChecked([])
      setAllChecked(false)
      return
    }
    const founded = checked.find((item:any) => item.id === id?.id)
    if(founded) {
      if(isAll){ 
        return 
      } else {
        setChecked((prev:any) => {
          return prev.filter((item:any) => item.id !== id?.id)
        })
        setAllChecked(false)
      }
    } else {
      setChecked((prev) => [...prev, id])
    }
  } 
  useEffect(() => {
    if(compareArrays(flavors, checked) && checked?.length !== 0){
      setAllChecked(true)
    }
  },[checked])
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const {setDataToLs} = useLocalStorage()
  const navigate = useNavigate()
  const theme:any = useTheme()
  useEffect(() => {
    if (!ordering) {
      setOrdering(DEFAULT_ORDERING);
    }
  }, [ordering, setOrdering]);


  const _updateFlavors = () => {
    // setLoading(true)
    flavorService.getFlavors({
      page:page || 1,
      page_size:pageSize || 10,
      ordering:ordering || DEFAULT_ORDERING,
      search:searchString||'',
      filtering: filtering || '',
    })
    .then((res) => {
      setFilterOptions(res?.data?.filter_options);
      setFlavors(res.data.objects.map((flavor:any) => {
        return {
          ...flavor,
          navigate: `/openstack/flavors/${flavor.id}`,
          vcpus: flavor.vcpus,
          memory_mb: `${(flavor.memory_mb / 1024).toFixed(1)} GB (${flavor.memory_mb} MB)`,
          disk_gb: `${flavor.root_gb} GB`,
          ephemeral_gb: `${flavor.ephemeral_gb} GB`,
          swap: `${flavor.swap} MB`,
          name: flavor.name || flavor.display_name || flavor.id,
          is_public: flavor.is_public ? `${t("YES")}` : `${t("NO")}`,
          out_of_stock: flavor.out_of_stock ? `${t("YES")}` : `${t("NO")}`,
          created_at: timeConverterMMDDYYHHMM(flavor.created_at),
          status:(
            <StateWrapper>
              <GreenDot active={!flavor.out_of_stock ? "available" : "out_of_stock"}/>
              <Greentext active={!flavor.out_of_stock ? "available" : "out_of_stock"}>
                {handleStatusName(flavor.out_of_stock ? "out_of_stock" : "available", t)}
              </Greentext>
            </StateWrapper>),
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
    })
    .catch((e) => {
      viewAlert({
        severity:'error',
        message:e?.response?.data?.detail || `${t("ERROR_OCCURRED")}`,
      })
      navigate('/home')
      setPageLoading(false)
    })
  }
  useEffect(() => {
    _updateFlavors()
    const interval = setInterval(() => {
      _updateFlavors()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,
    searchString,
    filtering])
  useUpdateEffect(() => {
    setPage(1)
  }, [pageSize, filtering])

  const items = [
    {
      title:t("EDIT"),
      id:'3',
      icon:icons.Edit,
      onClick: (flavor:any) => {
        navigate(`/openstack/flavors/${flavor.id}/edit`)
      },
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      onClick:(flavor:any) => {
        openModal('delete')
        setAlertTitle(t("FLAVOR"))
        setAlertSubTitle([flavor])
        setDeletedFlavor(flavor)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]

  const Columns = [
    {
      title:t("NAME"),
      key:'name',
    },
    {
      title:t("STATUS"),
      key:'status'
    },
    {
      title:t("VCPUS"),
      key:'vcpus'
    },
    {
      title:t("MEMORY"),
      key:'memory_mb'
    },
    {
      title:t("DISK"),
      key:'disk_gb'
    },
    {
      title:t("EPHEMERAL"),
      key:'ephemeral_gb'
    },
    {
      title:t("SWAP"),
      key:'swap'
    },
    {
      title:t("PUBLIC"),
      key:'is_public'
    },
    {
      title:'',
      key:'props'
    },
  ]

  const _deleteFlavors = async () => {
    setLoading(true)
    try{
      if(allChecked) {
        let promises:any[] = []
        await flavors.map(async(item:any) => {
          let promise = await flavorService.deleteFlavor(item.id)
          await promises.push(promise)
        })
        await Promise.all(promises)
        await _updateFlavors()
        await setAllChecked(false)
      } else if (checked?.length > 0){
        let promises:any[] = []
        await checked.map((item:any) => {
          let promise = flavorService.deleteFlavor(item.id)
          promises.push(promise)
        })
        await Promise.all(promises)
        await _updateFlavors()
        await setChecked([])
      } else if (deletedFlavor) {
        await flavorService.deleteFlavor(deletedFlavor.id)
        await _updateFlavors()
      }
    } catch (e:any) {
      if(e?.response?.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      }
      _updateFlavors()
      setPageLoading(false)
    } finally {
      setViewModal(false)
      setActiveAnimation(false)
      setLoading(false)
    }
  }

  const closeModal = (props:any) => {
    if(modalType === 'delete'){
      _deleteFlavors()
    }
  }

  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
    setDeletedFlavor(null)
  }


  const _createFunc = () => {
    navigate('/openstack/flavors/create')
  }
  return (
    <>
      <StartPage
        title={`${t("FLAVORS")}`}
        noResourceText={`${t("NO_FLAVORS")}`}
        createResourceButton={`${t('CREATE_FLAVOR')}`}
        createResourceButtonEventOrLink={_createFunc}
        haveResource={flavors.length > 0}
        learnMoreAboutResource={`${t('LEARN_MORE_FLAVORS')}`}
        howCreateVideoText={`${t('HOW_CREATE_FLAVOR')}`}
        learnMoreAboutResourceLink={`${rootConfig.docs_url}category/flavors`}
        withoutCreateResourceButton
        rightCustomCreateButton={
          <div style={{display:'flex', flexDirection:'column', gap:'10px', width:'100%'}}>
            <div style={{display:'flex', alignItems:'center', gap:'12px', width:'100%'}}>
              <Button
                title={t('CREATE_FLAVOR')}
                onClick={_createFunc}
                variant='primary'
                size='custom'
                customStyles={{height:'40px', whiteSpace:'nowrap'}}
              />
              <div style={{flex:1, minWidth:'200px'}}>
                <SearchComponent />
              </div>
              <div style={{display:'flex', alignItems:'center', gap:'8px', marginLeft:'auto'}}>
                <Button
                  onClick={() => {
                    setAlertTitle(t("FLAVORS"))
                    setAlertSubTitle(allChecked ? flavors : checked)
                    openModal('delete')
                  }}
                  variant='icon'
                  size='display'
                  test_id='button-delete'
                  disabled={!allChecked && checked?.length === 0 }
                >
                  <img src={icons.DeleteIcon}/>
                </Button>
                <Button
                  title={t("CLEAR_FILTERS")}
                  onClick={handleResetFilters}
                  variant='stroke'
                  size='display'
                  disabled={
                    (!filtering || filtering === '') &&
                    !searchString &&
                    ordering === DEFAULT_ORDERING
                  }
                />
              </div>
            </div>
            {normalizedFilterOptions ? (
              <FilterBar filterOptions={normalizedFilterOptions} />
            ) : null}
          </div>
        }
        videoImage={TutorImg}
        videoImageDark={TutorDarkImg}
        pageLoading={pageLoading}
        tableData={{
          columns:Columns,
          data:flavors,
          props:items,
          allChecked:allChecked,
          setAllChecked:setAllChecked,
          checked:checked,
          setChecked:editChecked,
          paginationData:paginationData,
          updateData:_updateFlavors
        }}
      />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
        instance={deletedFlavor}
      />
    </>
  )
}


export default Flavors
